import React, {useState, useEffect, useRef} from "react";
import axios from "axios";
import {jwtDecode} from "jwt-decode";
import "bootstrap/dist/css/bootstrap.min.css";

// استخراج adminId من JWT token
const getAdminIdFromToken = () => {
    const token = localStorage.getItem("FORCE_GYM_TOKEN");
    if (!token) return null;
    try {
        const decoded = jwtDecode(token);
        return decoded.user_id || decoded.id; // حسب payload في التوكن
    } catch (e) {
        console.error("Invalid token", e);
        return null;
    }
};

export default function AdminChatArabic() {
    const [adminId, setAdminId] = useState(null);
    const [members, setMembers] = useState([]);
    const [selectedMember, setSelectedMember] = useState(null);
    const [messages, setMessages] = useState([]);
    const [newMessage, setNewMessage] = useState("");
    const textareaRef = useRef(null);
    const messagesContainerRef = useRef(null);
    const [searchTerm, setSearchTerm] = useState("");
    const [unreadCounts, setUnreadCounts] = useState({});


    const filteredMembers = members.filter((m) =>
        m.full_name.toLowerCase().includes(searchTerm.toLowerCase())
    );


    useEffect(() => {
        if (!adminId) return;

        const fetchUnreadCounts = async () => {
            try {
                const token = localStorage.getItem("FORCE_GYM_TOKEN");
                const res = await axios.get(
                    `${process.env.REACT_APP_BACKEND_URL}/api/messages/unread/admin/${adminId}`,
                    { headers: { Authorization: `Bearer ${token}` } }
                );

                const counts = {};
                res.data.forEach((r) => (counts[r.sender_id] = r.unreadCount));
                setUnreadCounts(counts);
            } catch (err) {
                console.error("Error fetching unread counts:", err);
            }
        };

        fetchUnreadCounts();
        const interval = setInterval(fetchUnreadCounts, 5000);
        return () => clearInterval(interval);
    }, [adminId]);

    const markAsRead = async (memberId) => {
        try {
            const token = localStorage.getItem("FORCE_GYM_TOKEN");
            await axios.post(
                `${process.env.REACT_APP_BACKEND_URL}/api/messages/read`,
                { sender_id: memberId, receiver_id: adminId },
                { headers: { Authorization: `Bearer ${token}` } }
            );
            setUnreadCounts((prev) => ({ ...prev, [memberId]: 0 }));
        } catch (err) {
            console.error("Failed to mark as read:", err);
        }
    };



    // استخراج adminId عند تحميل الصفحة
    useEffect(() => {
        const id = getAdminIdFromToken();
        if (!id) {
            console.error("Admin not logged in!");
            return;
        }
        setAdminId(id);
    }, []);

    // جلب جميع الأعضاء
    const fetchMembers = async () => {
        try {
            const token = localStorage.getItem("FORCE_GYM_TOKEN");
            const res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/members`, {
                headers: {Authorization: `Bearer ${token}`},
            });
            setMembers(res.data.filter(m => m.role !== "admin"));
        } catch (err) {
            console.error(err);
        }
    };

    useEffect(() => {
        if (!adminId) return;
        fetchMembers();
    }, [adminId]);

    // جلب الرسائل بين الأدمن والعضو المحدد
    const fetchMessages = async (memberId) => {
        if (!adminId) return;
        try {
            const token = localStorage.getItem("FORCE_GYM_TOKEN");
            const res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/messages/${adminId}/${memberId}`, {
                headers: {Authorization: `Bearer ${token}`},
            });
            setMessages(prev => {
                if (JSON.stringify(prev) !== JSON.stringify(res.data)) {
                    return res.data;
                }
                return prev;
            });
        } catch (err) {
            console.error(err);
        }
    };

    useEffect(() => {
        if (!selectedMember || !adminId) return;

        fetchMessages(selectedMember.id);
        const interval = setInterval(() => fetchMessages(selectedMember.id), 3000);
        return () => clearInterval(interval);
    }, [selectedMember, adminId]);

    // إرسال رسالة جديدة
    const sendMessage = async () => {
        if (!newMessage.trim() || !selectedMember || !adminId) return;

        try {
            const token = localStorage.getItem("FORCE_GYM_TOKEN");
            await axios.post(
                `${process.env.REACT_APP_BACKEND_URL}/api/messages`,
                {
                    sender_id: adminId,
                    receiver_id: selectedMember.id,
                    message: newMessage,
                },
                {
                    headers: {Authorization: `Bearer ${token}`},
                }
            );
            setNewMessage("");
            fetchMessages(selectedMember.id);
        } catch (err) {
            console.error(err);
        }
    };
    useEffect(() => {
        if (textareaRef.current) {
            textareaRef.current.style.height = "auto";
            textareaRef.current.style.height =
                Math.min(textareaRef.current.scrollHeight, 134) + "px";
        }
    }, [newMessage]);

    useEffect(() => {
        if (messagesContainerRef.current)
            messagesContainerRef.current.scrollTop =
                messagesContainerRef.current.scrollHeight;
    }, [messages]);

    return (
        <div
            className="container-fluid"
            dir="rtl"
            style={{height: "100vh", width: "80%", marginLeft: "5%"}}
        >
            <div className="row h-100">
                {/* نافذة المحادثة */}
                <div className="col-md-9 d-flex flex-column border rounded shadow-sm p-0">
                    {selectedMember ? (
                        <>
                            {/* الهيدر */}
                            <div
                                className="d-flex align-items-center justify-content-between p-3 border-bottom bg-light"
                                style={{height: "70px"}}
                            >
                                <div className="d-flex align-items-center">
                                    <img
                                        src={`${process.env.REACT_APP_BACKEND_URL}/profile/${selectedMember.profile_image || "default-profile.jpeg"}`}
                                        alt={selectedMember.full_name}
                                        className="rounded-circle ms-2"
                                        width={45}
                                        height={45}
                                        style={{
                                            objectFit: "cover",
                                            border: "2px solid #ddd",
                                            boxShadow: "0 0 6px rgba(0,0,0,0.2)"
                                        }}
                                        onError={(e) => { e.target.src = `${process.env.REACT_APP_BACKEND_URL}/profile/default-profile.jpeg`; }}
                                    />
                                    <div>
                                        <h6 className="mb-0">الدردشة مع {selectedMember.full_name}</h6>
                                        <small className="text-muted">عضو بالنادي</small>
                                    </div>
                                </div>
                            </div>

                            {/* الرسائل */}
                            <div
                                ref={messagesContainerRef}
                                className="p-3"
                                style={{
                                    backgroundColor: "#fafafa",
                                    display: "flex",
                                    flexDirection: "column",
                                    height: "calc(100vh - 220px)",
                                    overflowY: "auto",
                                    borderTop: "1px solid #ddd",
                                    borderBottom: "1px solid #ddd",
                                    scrollbarWidth: "thin",
                                    scrollbarColor: "#bbb #eee"
                                }}
                            >
                                {messages.map((msg) => (
                                    <div
                                        key={msg.id}
                                        className={`d-flex mb-2 ${
                                            msg.sender_id === adminId
                                                ? "justify-content-start"
                                                : "justify-content-end"
                                        }`}
                                    >
                                        <div
                                            className="p-3"
                                            style={{
                                                background:
                                                    msg.sender_id === adminId
                                                        ? "linear-gradient(135deg, #d1e7dd, #b8dfc3)"
                                                        : "linear-gradient(135deg, #f8d7da, #f5c6cb)",
                                                borderRadius: "20px",
                                                maxWidth: "70%",
                                                minWidth: "30%",
                                                wordBreak: "break-word",
                                                boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
                                                border: "1px solid rgba(0,0,0,0.05)",
                                            }}
                                        >
                                            {msg.message}
                                            <br/>
                                            <small className="text-muted" style={{fontSize: "0.7rem"}}>
                                                {new Date(msg.created_at).toLocaleString("ar-EG")}
                                            </small>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            {/* الإدخال */}
                            <div
                                className="p-3  bg-white d-flex align-items-end flex-shrink-0 mt-3"
                                style={{height: "auto"}}
                            >
                <textarea
                    ref={textareaRef}
                    className="form-control me-2"
                    placeholder="اكتب رسالتك هنا..."
                    value={newMessage}
                    onChange={(e) => setNewMessage(e.target.value)}
                    style={{
                        resize: "none",
                        overflowY: "auto",
                        minHeight: "50px",
                        maxHeight: "120px",
                        flex: 1,
                        borderRadius: "20px",
                        border: "1px solid #ced4da",
                        padding: "10px 15px",
                        fontSize: "0.95rem",
                        boxShadow: "inset 0 1px 3px rgba(0,0,0,0.1)",
                        backgroundColor: "#f8f9fa",
                    }}
                    rows={1}
                    dir="rtl"
                    onKeyDown={(e) => {
                        if (e.key === "Enter" && !e.shiftKey) {
                            e.preventDefault();
                            sendMessage();
                        }
                    }}
                />
                                <button
                                    className="btn btn-primary d-flex align-items-center justify-content-center me-3 "
                                    style={{
                                        borderRadius: "50%",
                                        width: "45px",
                                        height: "45px",
                                        padding: 0,
                                        marginLeft: "5px",
                                        boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
                                    }}
                                    onClick={sendMessage}
                                >
                                    <i className="bi bi-send-fill"></i>
                                </button>
                            </div>
                        </>
                    ) : (
                        <div className="d-flex align-items-center justify-content-center flex-grow-1">
                            <p className="text-muted">اختر عضوًا من القائمة لبدء الدردشة.</p>
                        </div>
                    )}
                </div>

                {/* الشريط الجانبي - الأعضاء على اليمين */}
                <div
                    className="col-md-3 border-start rounded p-3 order-2"
                    style={{
                        backgroundColor: "#f1f1f1",
                        overflowY: "auto",
                        maxHeight: "100vh",
                        direction: "rtl",
                        scrollbarWidth: "thin",
                        scrollbarColor: "#888 #e0e0e0"
                    }}
                >
                    <h5 className="text-center mb-3">الأعضاء</h5>

                    {/* 🔍 شريط البحث */}
                    <input
                        type="text"
                        className="form-control mb-3 text-end"
                        placeholder="ابحث عن عضو..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        style={{borderRadius: "15px"}}
                    />

                    {/* 🧍 قائمة الأعضاء */}
                    {filteredMembers.length === 0 ? (
                        <p className="text-center text-muted">لا يوجد أعضاء</p>
                    ) : (
                        filteredMembers.map((member) => (
                            <div
                                key={member.id}
                                onClick={() => {
                                    setSelectedMember(member);
                                    markAsRead(member.id);
                                }}
                                className={`d-flex align-items-center justify-content-between p-2 mb-2 rounded shadow-sm transition-all ${
                                    selectedMember?.id === member.id
                                        ? "bg-primary text-white"
                                        : "bg-white text-dark"
                                }`}
                                style={{
                                    cursor: "pointer",
                                    border: "1px solid #ddd",
                                    transition: "all 0.2s ease-in-out",
                                }}
                                onMouseEnter={(e) => {
                                    if (selectedMember?.id !== member.id)
                                        e.currentTarget.style.backgroundColor = "#f8f9fa";
                                }}
                                onMouseLeave={(e) => {
                                    if (selectedMember?.id !== member.id)
                                        e.currentTarget.style.backgroundColor = "#fff";
                                }}
                            >
                                <div className="d-flex align-items-center justify-content-between w-100">
                                    <div className="d-flex align-items-center">
                                        <img
                                            src={`${process.env.REACT_APP_BACKEND_URL}/profile/${member.profile_image || "default-profile.jpeg"}`}
                                            alt={member.full_name}
                                            className="me-2"
                                            style={{
                                                width: "40px",
                                                height: "40px",
                                                borderRadius: "50%",
                                                objectFit: "cover",
                                                border: "2px solid #ddd",
                                                boxShadow: "0 0 5px rgba(0,0,0,0.1)"
                                            }}
                                            onError={(e) => { e.target.src = `${process.env.REACT_APP_BACKEND_URL}/profile/default-profile.jpeg`; }}
                                        />

                                        <span className="me-3">{member.full_name}</span>
                                    </div>

                                    {unreadCounts[member.id] > 0 && (
                                        <span
                                            className="badge bg-danger rounded-pill"
                                            style={{ fontSize: "0.75rem", minWidth: "25px", textAlign: "center" }}
                                        >
            {unreadCounts[member.id] > 9 ? "9+" : unreadCounts[member.id]}
        </span>
                                    )}
                                </div>

                            </div>
                        ))
                    )}
                </div>
            </div>
        </div>
    );
}
